import { Component, computed, signal } from "@angular/core";
import { LiquidElementImage, LiquidImage } from "../../../liquid-page.models";

@Component({
    selector: 'meta-liquid-image',
    templateUrl: './liquid-image.component.html',
    styleUrls: ['./liquid-image.component.css'],
})
export class LiquidImageComponent {
    $input = signal<LiquidElementImage | undefined>(undefined);
    $output = computed<LiquidImage>(() => {
        if (this.$input()) {
            return { src: this.$input()?.value };
        }

        return { src: undefined };
    })
}